import {
  getAuth,
  getIdToken,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  updateProfile,
  signInWithEmailAndPassword,
  signOut,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  sendPasswordResetEmail,
  sendEmailVerification,
  applyActionCode,
  verifyPasswordResetCode,
  confirmPasswordReset,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth'


export default {
  getCurrentUser: () => {
    const auth = getAuth()
    return auth.currentUser
  },

  onAuthStateChanged: () => {
    return new Promise((resolve, reject) => {
      try {
        const auth = getAuth()
        onAuthStateChanged(auth, (user) => {
          resolve(user)
        })
      } catch (err) {
        reject(err)
      }
    })
  },

  getIdToken: () => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      const user = auth.currentUser
      getIdToken(user, true)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  createUser: (vals) => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      createUserWithEmailAndPassword(auth, vals.email, vals.password)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  updateProfile: (vals) => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      updateProfile(auth.currentUser, {
        displayName: vals.displayName,
      })
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  signIn: (vals) => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      signInWithEmailAndPassword(auth, vals.email, vals.password)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  signOut: () => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      signOut(auth)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  sendSignInLinkToEmail: (email, actionCodeSettings) => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      sendSignInLinkToEmail(auth, email, actionCodeSettings)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  signInWithEmailLink: (email, currentUrl) => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      signInWithEmailLink(auth, email, currentUrl)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  sendPasswordResetEmail: (email) => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      sendPasswordResetEmail(auth, email)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  sendEmailVerification: () => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      sendEmailVerification(auth.currentUser)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  verifyEmail: (actionCode) => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      applyActionCode(auth, actionCode)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  verifyPasswordResetCode: (actionCode) => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      verifyPasswordResetCode(auth, actionCode)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  confirmPasswordReset: (actionCode, newPassword) => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      confirmPasswordReset(auth, actionCode, newPassword)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },

  signInWithOAuthGoogle: () => {
    return new Promise((resolve, reject) => {
      const auth = getAuth()
      const provider = new GoogleAuthProvider()
      signInWithPopup(auth, provider)
        .then(res => resolve(res))
        .catch(err => reject(err))
    })
  },
}

